export default "<app-estimations-list></app-estimations-list>";